import api from "api"

const labels = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/labels`)
    },
    update: (slug, payload) => {
        return api().put(`/events/detail/${slug}/labels`, payload)
    },
    generate: (slug, payload) => {
        return api().post(`/events/detail/${slug}/labels/generate`, payload, { responseType: 'blob' })
    },
}

export default labels
